import React, { useEffect, useRef } from 'react';
import LazyLoad from "react-lazy-load";

const Video = ({ src, className }) => {
    const videoRef = useRef();

    const handleCanPlayThrough = () => {
    };

    return (
        <LazyLoad>
            <video
                ref={videoRef}
                className={className}
                preload="metadata"
                autoPlay
                loop
                muted
                loading="lazy"
                playsInline
                onCanPlayThrough={handleCanPlayThrough}
            >
                <source src={src} />
        </video>
        </LazyLoad>
    );
};

export default Video;